"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchTerm = exports.ClearSearchButton = exports.SearchTermContainer = void 0;
const tslib_1 = require("tslib");
const theme_1 = require("@monorepo/theme");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
exports.SearchTermContainer = styled_components_1.default.div `
  width: 100%;
  display: flex;
  align-items: center;
`;
exports.ClearSearchButton = styled_components_1.default.button `
  width: 22px;
  height: 22px;
  margin: 0 5px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background-color: transparent;
  transition: background-color 0.25s ease-in-out;
  outline: unset;
  cursor: pointer;

  &:hover:not(:disabled) {
    background-color: ${theme_1.colors.lightGrey};
  }
`;
exports.SearchTerm = styled_components_1.default.strong `
  font-weight: 600;
  margin: 0 10px 0 5px;
`;
